import api from '@/client/axiosInstance';
import axios from 'axios';
import { Notification } from '@/types';

const handleError = (error: unknown, message: string): never => {
  if (axios.isAxiosError(error)) {
    throw new Error(
      `${message}: ${error.response?.data?.message || error.message}`,
    );
  } else {
    throw new Error(`${message}: Unknown error occurred`);
  }
};

export const getNotifications = async ({
  page = 1,
  limit = 10,
}: {
  page?: number;
  limit?: number;
}): Promise<Notification[]> => {
  try {
    const response = await api.get('users/notifications', {
      params: {
        page,
        limit,
      },
    });
    return response.data;
  } catch (error) {
    handleError(error, 'Error fetching notifications');
    return [];
  }
};

export const markNotificationRead = async () => {
  try {
    const response = await api.post(`users/notifications/read`);
    return response.data;
  } catch (error) {
    handleError(error, 'Error marking notification as read');
    return false;
  }
};
